let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hKgWQ")).then(() => parcelRequire('dHrmQ'));